import React from 'react';
import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  Divider,
  IconButton,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import MuiDialogTitle from '@mui/material/DialogTitle';
import { CloseOutlined } from '@mui/icons-material';
import ToastHandler from 'components/Toast-Handler/toast-handler';

const StyledDialogTitle = styled(MuiDialogTitle)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(1),
  paddingRight: theme.spacing(3),
}));

const DialogTitle = ({ children, onClose }) => (
  <StyledDialogTitle>
    <Typography variant='subtitle1'>{children}</Typography>
    <Box display='flex' alignItems='center' gap={2}>
      <IconButton
        aria-label="close"
        onClick={onClose}
        size="large">
        <CloseOutlined />
      </IconButton>
    </Box>
  </StyledDialogTitle>
);

const DataDialog = ({
  open,
  title,
  children,
  width,
  isProcessing,
  toast,  
  onCloseHandler,
}) => {
  return (
    <Dialog
      maxWidth={width ? width : 'md'}
      fullWidth
      open={open}
      onClose={onCloseHandler}
    >
      <DialogTitle
        onClose={onCloseHandler}
      >
        {title}
      </DialogTitle>
      <Divider style={{ marginBottom: '5px' }} />
      <DialogContent>
        <Box m={1}>
          {isProcessing && <CircularProgress style={{margin: '0px 50%'}} />}
          {toast && toast.type && <ToastHandler toast={toast} type={toast.type} /> }
        </Box>
        {children}
      </DialogContent>
    </Dialog>
  );
};
export default DataDialog;